export const PREFIX = 'urn';
export const SEPARATOR = ':';

export const COMPONENTS = [
  'nid',
  'nss',
];
